module.exports = __webpack_public_path__ + "static/media/gray-left-arrow.3e90957e.svg";